module.exports = __webpack_public_path__ + "img/google-play.6df000cf.svg";